export default function ({ store, redirect, app }) {
  if (!store.getters['user/getActiveUser'].token)
    redirect(app.localePath('/giris-yap'))
}
